import StepSuccess from './step-success';

export default StepSuccess;
